<div style="width: 500px; height: 800px;" data-cy="fee-schedule-import-cvs-container">

  <div style="background-color: #1f69ec" data-cy="fee-schedule-import-cvs-header">
    <div data-cy="fee-schedule-import-cvs-title">Import a price list from comma separated list</div>
  </div>

  <div style="font-size: 11px;   display:flex;flex-direction: column; " *ngIf="importMessages.length==0" data-cy="fee-schedule-import-cvs-input-form">

    <span data-cy="fee-schedule-import-cvs-instruction-1">Open the CVS file in a text editor and copy the content into clipboard.</span>
    <span data-cy="fee-schedule-import-cvs-instruction-2">Format of a row should be:   code,price,description </span>


    <dx-button text="Paste" (onClick)="onClickPaste()" data-cy="fee-schedule-import-cvs-paste-button"></dx-button>


    <textarea style="font-family: 'Courier New'; font-size: small; height:200px ; border-width: 0px;" wrap="off" [(ngModel)]="csvText" data-cy="fee-schedule-import-cvs-text-area">  </textarea>

<!--    <dx-text-area  wrap="off"-->
<!--      height="150"-->

<!--      [(value)]="csvText"-->

<!--      (onValueChanged)="onValueChaged()"-->
<!--    >-->
<!--    </dx-text-area>-->


      <dx-button style="float: left" text="Validate" (onClick)="onClickValidate()" data-cy="fee-schedule-import-cvs-validate-button"></dx-button>

      <span style="float: left" data-cy="fee-schedule-import-cvs-validation-result-label">Validation Result</span>

    <dx-data-grid *ngIf="priceList"
      [dataSource]="priceList"
      height="400"
      data-cy="fee-schedule-import-cvs-data-grid"
    >
      <dxo-paging [enabled]="false" data-cy="fee-schedule-import-cvs-paging"></dxo-paging>

      <dxi-column dataField="code" caption="Code" [width]="100" data-cy="fee-schedule-import-cvs-code-column"></dxi-column>
      <dxi-column dataField="sprice" caption="To Convert" [width]="100" data-cy="fee-schedule-import-cvs-sprice-column"></dxi-column>
      <dxi-column dataField="price" caption="Prince" dataType="number" [format]="{ type: 'currency', currency: 'USD', precision: 2  }" [width]="100" data-cy="fee-schedule-import-cvs-price-column"></dxi-column>
      <dxi-column dataField="description" caption="Description" data-cy="fee-schedule-import-cvs-description-column"></dxi-column>

    </dx-data-grid>

    <span *ngIf="parseErrors.length>0" data-cy="fee-schedule-import-cvs-error-label">Error List</span>

    <dx-list *ngIf="parseErrors.length>0" style="background-color: red; color: #00ffbd"
      [dataSource]="parseErrors"
      height="100"
      data-cy="fee-schedule-import-cvs-error-list"></dx-list>



    <dx-button *ngIf="parseErrors.length==0 && priceList.length>0"
      [text] = "uploadButtonText"
      (onClick)="onClickImport()"
      data-cy="fee-schedule-import-cvs-import-button"
    >

      <div *ngIf="uploading" class="dx-button-spinner" data-cy="fee-schedule-import-cvs-spinner">
        <dx-load-indicator
          [visible]="true"
          [height]="20"
          [width]="20"
          data-cy="fee-schedule-import-cvs-load-indicator"
        ></dx-load-indicator>
      </div>
      <div *ngIf="!uploading" data-cy="fee-schedule-import-cvs-button-text">
        {{ uploadButtonText }}
      </div>
    </dx-button>
    <div *ngIf="uploading" data-cy="fee-schedule-import-cvs-uploading-message">
      This will take about 1min ... please be patient ...
    </div>

  </div>

  <div style=" display:flex;flex-direction: column;" *ngIf="importMessages.length>0" data-cy="fee-schedule-import-cvs-result-container">
    <div data-cy="fee-schedule-import-cvs-log-label">Import Log</div>
    <dx-list style="background-color: #00ffbd; color: darkblue;"
      [dataSource]="importMessages"
      height="600"
      data-cy="fee-schedule-import-cvs-import-log">
    </dx-list>

    <dx-button icon="copy" text="OK" (onClick)="onImportOKClick()" data-cy="fee-schedule-import-cvs-ok-button"></dx-button>

  </div>

</div>

